import * as React from 'react';
import { isIosReg } from '@/utils/instantLoaded/constants';

const { userAgent } = window.navigator;
const isIos = isIosReg.test(userAgent);

interface VisualViewportComponentProps {
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

interface VisualViewportComponentState {
  visualViewport: VisualViewport | null;
  windowInnerWidth: number;
  windowInnerHeight: number;
}

export default class VisualViewportComponent extends React.Component<VisualViewportComponentProps, VisualViewportComponentState> {
  state: VisualViewportComponentState = {
    visualViewport: null,
    windowInnerWidth: window.innerWidth,
    windowInnerHeight: window.innerHeight,
  };

  componentDidMount() {
    // 挂载事件监听器
    if (typeof window.visualViewport !== 'undefined') {
      window.visualViewport?.addEventListener('resize', this.onVisualViewportChange);
      window.visualViewport?.addEventListener('scroll', this.onVisualViewportChange);
    }
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    // 卸载事件监听器
    if (typeof window.visualViewport !== 'undefined') {
      window.visualViewport?.removeEventListener('resize', this.onVisualViewportChange);
      window.visualViewport?.removeEventListener('scroll', this.onVisualViewportChange);
    }
    window.removeEventListener('resize', this.onResize);
  }

  onVisualViewportChange = (e: Event) => {
    this.setState({ visualViewport: e.target as VisualViewport || window.visualViewport });
  };

  onResize = () => {
    this.setState({
      windowInnerWidth: window.innerWidth,
      windowInnerHeight: window.innerHeight,
    });
  };

  getStyles(): React.CSSProperties {
    // 根据 state 计算样式
    const {
      visualViewport,
      windowInnerWidth,
      windowInnerHeight,
    } = this.state;

    // 开启 3D Transform，让 fixed 的子元素相对于容器定位
    // 同时自身也设置为 fixed，以便在非放大情况下不需要频繁移动位置
    const styles: React.CSSProperties = {
      position: 'fixed',
      transform: 'translateZ(0)',
      ...this.props.style || {},
    };

    // 支持 VisualViewport API 情况下直接计算
    if (isIos && visualViewport != null) {
      // 需要针对 iOS 越界弹性滚动的情况进行边界检查
      styles.left = Math.max(0, Math.min(
        document.documentElement.scrollWidth - visualViewport.width,
        visualViewport.offsetLeft,
      )) + 'px';

      // 需要针对 iOS 越界弹性滚动的情况进行边界检查
      styles.top = Math.max(0, Math.min(
        document.documentElement.scrollHeight - visualViewport.height,
        visualViewport.offsetTop,
      )) + 'px';

      styles.width = visualViewport.width + 'px';
      styles.height = visualViewport.height + 'px';
    } else {
      // Android 以及
      // 不支持 VisualViewport API 情况下（如 iOS 8~12）
      styles.top = '0';
      styles.left = '0';
      styles.width = '100%'; // windowInnerWidth + 'px';
      styles.height = '100%'; // windowInnerHeight + 'px';
    }

    return styles;
  }

  render() {
    return <div id={this.props.id || ''} className={'visual-viewport ' + (this.props.className || '')} style={this.getStyles()}>
      {this.props.children}
    </div>;
  }
}
